import BackendService from "../../service/BackendService";

class SessionsRepository {
  constructor() {
    this.backendService = new BackendService("sessions");
  }

  async getSessionsById(id) {
    const session = await this.backendService.getOne(id);
    return session;
  }

  async getSessionReport(id) {
    const apiUrl = `${this.backendService.collectionUrl("sessions")}${id}/report`;
    const accessToken = this.backendService.getAccessToken();
    const response = await this.backendService.instance.get(apiUrl, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  }

  async getSessionsByStudentId(id) {
    const sessions = await this.backendService.getManyByFieldId("student", id);
    return sessions;
  }

  async getSessionBySectionId(id) {
    const sessions = await this.backendService.getManyByFieldId("section", id);
    return sessions;
  }

  async updateSession(id, postData) {
    return await this.backendService.updateOne(id, postData);
  }

  async _postSubPath(id, subPath, data) {
    const apiUrl = `${this.backendService.collectionUrl("sessions")}${id}/${subPath}`;
    const accessToken = this.backendService.getAccessToken();
    const response = await this.backendService.instance.post(apiUrl, data, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  }

  async _putSubPath(id, subPath, data) {
    const apiUrl = `${this.backendService.collectionUrl("sessions")}${id}/${subPath}`;
    const accessToken = this.backendService.getAccessToken();
    const response = await this.backendService.instance.put(apiUrl, data, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  }

  async submitReadingReport(id, data) {
    return await this._postSubPath(id, "reading-report", data);
  }

  async scoreAnswers(id, data) {
    return await this._putSubPath(id, "score-answers", data);
  }

  async evaluateSession(id) {
    return await this._putSubPath(id, "evaluate");
  }

  async decideSession(id, data) {
    return await this._putSubPath(id, "decide", data);
  }

  async getAssessmentProgress(studentId, classroomId) {
    const apiUrl = `${this.backendService.collectionUrl("sessions")}progress?studentId=${studentId}&classroomId=${classroomId}`;
    const accessToken = this.backendService.getAccessToken();
    const response = await this.backendService.instance.get(apiUrl, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  }
}

export default SessionsRepository;
